import TeamConfirmationModal from './TeamConfirmationModal';

export default TeamConfirmationModal;
